import classNames from 'classnames';
import styles from './AccordionSection.module.scss';

const AccordionSectionTabs = ({ children, classes = {} }) => {
  return <div className={classNames(styles['section-accordion'], classes.sectionAccordion)}>{children}</div>;
};

export { AccordionSectionTabs as default, AccordionSectionTabs };
